<template>
    <div id="test" class="test">num1</div>
    <div class="test">num2</div>
    <div class="test">num3</div>
    <div class="test">num4</div>
    <div class="test">num5
      <div v-scroll-to="'#test'">test</div>
    </div>
</template>

<script>
  export default {
    name: 'test'
  }
</script>

<style scoped>
  .test{
    /*width: 100vw;*/
    height: 100vh;
    box-sizing: border-box;
    padding: 10px;
    max-width:100%
  }
</style>
